import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import {
  PRIORITY_SELECT_OPTIONS,
  normalizeRequirementPriority,
} from '../../utils/requirementPriority';
import { updateRequirementPriority } from '../../services/requirementService';
import { showSuccess, showError } from '../../utils/toast';
import { getApiErrorMessage } from '../../utils/apiError';
import PriorityBadge from './PriorityBadge';

function PrioritySelect({
  requirementId,
  value,
  onUpdated,
  disabled = false,
  className = 'form-select form-select-sm hr-priority-select',
  showBadgePreview = false,
}) {
  const [saving, setSaving] = useState(false);
  const normalized = normalizeRequirementPriority(value);
  const selectValue = normalized === null ? '' : String(normalized);

  const handleChange = async (event) => {
    const rawValue = event.target.value;
    const nextPriority = rawValue === '' ? null : Number(rawValue);
    const currentPriority = normalized;

    if (!requirementId || nextPriority === currentPriority) return;

    setSaving(true);
    try {
      await updateRequirementPriority(requirementId, nextPriority);
      onUpdated?.(nextPriority);
      showSuccess('Requirement priority updated successfully ✓');
    } catch (error) {
      console.error('Requirement priority update failed:', error);
      showError(getApiErrorMessage(error, 'Failed to update requirement priority.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="hr-priority-select-wrap">
      {showBadgePreview && <PriorityBadge priority={value} className="me-2" />}
      <Form.Select
        size="sm"
        className={className}
        value={selectValue}
        onChange={handleChange}
        disabled={disabled || saving || !requirementId}
        aria-label="Requirement priority"
      >
        {PRIORITY_SELECT_OPTIONS.map((option) => (
          <option key={option.value || 'none'} value={option.value}>{option.label}</option>
        ))}
      </Form.Select>
    </div>
  );
}

export default PrioritySelect;
